export default __webpack_public_path__ + "static/media/happyEmoji.9a2e678e.svg";